(function(app, ng) {

    app.component("purchasePageComponent",
        {
            templateUrl: "App/Components/PurchasePage/purchase-page-template.component.html",
            controller: purchasePageComponentController,
            bindings: {
                purchaseModel: "<",  
                payComponentCallback: '&'
            }
        });

    purchasePageComponentController.$inject = ["purchaseApi", "$window"];
    function purchasePageComponentController(purchaseApi, $window) {
        var $ctrl = this;

        window.c = this; 
        ng.extend($ctrl,
            {
                getPaymentAmount: getPaymentAmount,
                purchase: purchase,
                goBack: goBack
            });
       
       

        function goBack()
        {
            var returnObj = {              
                action: "Back",
                surveyRenewalId: $ctrl.purchaseModel.ArcSurveyRenewalId
            };

            $ctrl.payComponentCallback({ callback: returnObj });
        }

        $ctrl.$onInit = function() {

            if ($ctrl.purchaseModel.PurchaseOptions.length === 1) {
                $ctrl.selectedPurchaseOption = "0";
                $ctrl.marketingDollarsToUse = null;
                getPaymentAmount();
            }           
        };      

        function getPaymentAmount() {            
            if ($ctrl.marketingDollarsToUse > $ctrl.marketingDollars) {
                $ctrl.marketingDollarsToUse = $ctrl.marketingDollars;
            }
            if ($ctrl.marketingDollarsToUse > $ctrl.purchaseModel.PurchaseOptions[$ctrl.selectedPurchaseOption].Amount) {
                $ctrl.marketingDollarsToUse = $ctrl.purchaseModel.PurchaseOptions[$ctrl.selectedPurchaseOption].Amount;
            }

            if ($ctrl.marketingDollarsToUse === null || $ctrl.marketingDollarsToUse < 0) {
                $ctrl.marketingDollarsToUse = 0;
            }        
            $ctrl.paymentAmount = $ctrl.purchaseModel.PurchaseOptions[$ctrl.selectedPurchaseOption].Amount - $ctrl.marketingDollarsToUse;
        }  

        function purchase(model) {
            
            $ctrl.submittingOrder = true;
            var order = { Description: model.Description };
            order.PaymentAmount = $ctrl.paymentAmount;
            order.ArcSurveyRenewalId = $ctrl.purchaseModel.ArcSurveyRenewalId;
            order.MarketingDollarsUsed = $ctrl.marketingDollarsToUse;
            order.MarketingStrategy = $ctrl.purchaseModel.MarketingStrategyName;
            order.Total = $ctrl.purchaseModel.PurchaseOptions[$ctrl.selectedPurchaseOption].Amount;
            if ($ctrl.purchaseModel.PurchaseOptions[$ctrl.selectedPurchaseOption].IsRecurringPayment)
                order.Frequency = 3;
            else
                order.Frequency = 0;
            
          
            //need to identify parameters
            return purchaseApi.purchase(order).then(function (response) {
                console.log(response)
                $ctrl.submittingOrder = false;              

                var returnObj = {};

                if ($ctrl.paymentAmount > 0) {
                    $window.open(response.payUrl, "_blank");                 

                    returnObj = {
                        orderId: response.orderId,
                        surveyRenewalId: order.ArcSurveyRenewalId,
                        action: "Order Submitted"
                    };
                }

                else {
                    returnObj = {
                        orderId: response.orderId,
                        surveyRenewalId: order.ArcSurveyRenewalId,
                        action: "Order Completed"
                    };
                }

                $ctrl.payComponentCallback({ callback: returnObj });               
            });
        }
    }

})(window.app, window.angular); //jshint ignore:line